import React from 'react';

const PlusSymbol = () => {
  return (
    <div className="plus">
      <svg style={{ padding: '0.1rem 0 0 0' }} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0C5.64175 0 5.35135 0.290416 5.35135 0.648649V5.35137H0.648649C0.290416 5.35137 0 5.64177 0 6.00002C0 6.35827 0.290416 6.64867 0.648649 6.64867H5.35135V11.3514C5.35135 11.7096 5.64175 12 6 12C6.35825 12 6.64865 11.7096 6.64865 11.3514V6.64867H11.3514C11.7096 6.64867 12 6.35827 12 6.00002C12 5.64177 11.7096 5.35137 11.3514 5.35137H6.64865V0.648649C6.64865 0.290416 6.35825 0 6 0Z" fill="#101316" />
      </svg>
    </div>
  );
};

export default PlusSymbol;
